const datastoreBase = `https://courses.ecampus.oregonstate.edu/services/datastore/public/`;

export const apiConfig = {
  baseApiUrl: import.meta.env.VITE_API_URL,
  datastore: {
    entry: `${datastoreBase}v1/entry`,
    entries: `${datastoreBase}v1/entries`
  }
};
